import { render, staticRenderFns } from "./RainGaugesLegend.vue?vue&type=template&id=53c90562&scoped=true"
import script from "./RainGaugesLegend.vue?vue&type=script&lang=ts"
export * from "./RainGaugesLegend.vue?vue&type=script&lang=ts"
import style0 from "./RainGaugesLegend.vue?vue&type=style&index=0&id=53c90562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c90562",
  null
  
)

export default component.exports